import { render, staticRenderFns } from "./orgEdit.vue?vue&type=template&id=78dc5355&scoped=true"
import script from "./orgEdit.vue?vue&type=script&lang=js"
export * from "./orgEdit.vue?vue&type=script&lang=js"
import style0 from "./orgEdit.vue?vue&type=style&index=0&id=78dc5355&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dc5355",
  null
  
)

export default component.exports